module.exports = __webpack_public_path__ + "storeHome/img/loading.d0802e98.gif";